import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

// Active vs archived sub-topic counts for a topic, used by the page header.
// Counts only (head: true) so no rows are transferred.
async function fetchSubTopicCounts(topicId: string) {
  const [active, archived] = await Promise.all([
    apiClient
      .from('sub_topics')
      .select('*', { count: 'exact', head: true })
      .eq('topic_id', topicId)
      .is('archived_at', null),
    apiClient
      .from('sub_topics')
      .select('*', { count: 'exact', head: true })
      .eq('topic_id', topicId)
      .not('archived_at', 'is', null),
  ]);

  if (active.error) {
    throw active.error;
  }
  if (archived.error) {
    throw archived.error;
  }

  return { active: active.count ?? 0, archived: archived.count ?? 0 };
}

export function useGetSubTopicCounts(topicId: string | undefined) {
  return useQuery({
    queryKey: keys.subTopicCounts(topicId ?? ''),
    queryFn: () => fetchSubTopicCounts(topicId!),
    enabled: !!topicId,
  });
}
